import Vue from 'vue'

Vue.component('Loader', () => import('@/view/content/Loader'))
Vue.component('ContentLoader', () => import('vue-content-loader'))
Vue.component('CardLoader', () => import('@/view/content/CardLoader'))
Vue.component('Card', () => import('@/components/Card'))
Vue.component('List', () => import('@/components/List'))
Vue.component('CustomPagination', () => import('@/components/CustomPagination'))
Vue.component('DetailModal', () => import('@/components/DetailModal'))
Vue.component('SecondModal', () => import('@/components/SecondModal'))
Vue.component('Filters', () => import('@/components/Filters'))
Vue.component('Label', () => import('@/components/Label'))
Vue.component('InfoBox', () => import('@/components/InfoBox'))

// Form elements
Vue.component('Input', () => import('@/components/formElements/Input'))
Vue.component('Textarea', () => import('@/components/formElements/Textarea'))
Vue.component('Select', () => import('@/components/formElements/Select'))
Vue.component('DateTime', () => import('@/components/formElements/DateTime'))
Vue.component('Checkbox', () => import('@/components/formElements/Checkbox'))
Vue.component('RangeSlider', () =>
  import('@/components/formElements/RangeSlider')
)
Vue.component('PasswordLabel', () =>
  import('@/components/formElements/PasswordLabel')
)
Vue.component('NumberInput', () =>
  import('@/components/formElements/NumberInput')
)
Vue.component('PasswordStrengthViewer', () =>
  import('@/components/formElements/PasswordStrengthViewer')
)
Vue.component('CopyButtonLabel', () =>
  import('@/components/formElements/CopyButtonLabel')
)
Vue.component('LineChart', () => import('@/components/formElements/LineChart'))
Vue.component('RadialBar', () => import('@/components/formElements/RadialBar'))
Vue.component('TabMenu', () => import('@/components/formElements/TabMenu'))
Vue.component('TabItem', () => import('@/components/formElements/TabItem'))
Vue.component('ShowMoreLabel', () =>
  import('@/components/formElements/ShowMoreLabel')
)

Vue.component('multiselect', () => import('vue-multiselect'))

// Buttons
Vue.component('PrimaryButton', () =>
  import('@/components/buttons/PrimaryButton')
)
Vue.component('ActionButton', () => import('@/components/buttons/ActionButton'))
Vue.component('GreenButton', () => import('@/components/buttons/GreenButton'))
Vue.component('WhiteButton', () => import('@/components/buttons/WhiteButton'))
Vue.component('LockButton', () => import('@/components/buttons/LockButton'))
Vue.component('SwitchButton', () => import('@/components/buttons/SwitchButton'))
Vue.component('DeleteButton', () => import('@/components/buttons/DeleteButton'))
Vue.component('DeleteOperation', () =>
  import('@/components/modals/DeleteOperation')
)
